module.exports = __webpack_public_path__ + "img/ricknmorty.842a6870.jpg";